export const groupColors = {
    'Vinimark Trading': '#6F7DAC',
    'Reyneke Wines': '#627B62',
    'Twee Jonge Gezellen': '#B34C23',
    'Robertson Winery': '#743A42',
};

export const facilityColors = {
    'Klapmuts': '#9D9D9D',
    'Head Office': '#AC6F7D',
    'Johannesburg': '#7DAC6F',
    'KZN': '#806FAC',
    'Mbombela': '#6F9CAC',
    'Gqeberha': '#E0B77C',
    'Reyneke Wines': '#A0AFA0',
    'Reyneke Wines Properties': '#445644',
    'Twee Jonge Gezellen': '#B34C23',
    'Robertson Winery': '#743A42',
}

/**
 * Colors for synthetic / organic
 */
export const fertilizerColors = {
    'Synthetic': '#CC0000',
    'Organic': '#6AA84F'
}

/**
 * Colors for herbicide / pesticide / insecticide
 */
export const agrochemicalsColors = {
    'Herbicide': '#CC0000',
    'Pesticide': '#F1C232',
    'Insecticide': '#6AA84F',
}

// --- BAR AND PIE CHARTS ---

// label for x-axis and y-axis (Month and Unit)
// x-axis - Names of each month
// y-axis - Each total increment
export const barGraphFontSize = 16;

//Size of the pie itself
export const outerRadius = 120

// x-axis Label offset
export const labelOffSet = -8;

/**
 * Controls the margins of the chart components
 */
export const composedChartMargin = { left: 20, right: 20, top: 5, bottom: 15 };
export const composedChartMarginForStackedGraph = { left: 20, right: 20, top: 5, bottom: 15 };

export const chartOffset = -5

/**
 * Controls the height of the colour legend icons that display next to groups/facilities
 */
export const legendIconSize = 12;
/**
 * Controls the height of the colour legend that displays groups/facilities
 */
export const legendHeight = 50;

/**
 * Controls the font size of the colour legend that displays groups/facilities
 */
export const legendFontSize = 18;

/**
 * Controls the height of the entire graph component
 */
export const responsiveContainerHeight = 450;

// --- STACKED BAR CHARTS ---

/**
 * Controls the width of the entire component
 */
export const stackedContainerWidth = '100%';
/**
 * Controls the gap between categories of each bar
 */
export const stackedBarCategoryGap = '25%';
/**
 * Controls the height of the entire component
 */
export const stackedContainerHeight = 600;
/**
 * Font size of all the text in the component, to normalize styling
 */
export const stackedGraphFontSize = 16;

// --- BOTH ---

/**
 * Normalizes the styling of the tooltip between the pie charts and the bar graphs
 */
export const customToolTipStyle = {
    borderRadius: 10,
    borderStyle: 'solid',
    borderColor: '#ccc',
    borderWidth: '1px',
    background: '#fff',
    padding: 8
}
/**
 * Controls the size of the individual bar within each category
 */
export const barSize = 100

/**
 * Controls the maximum width of the box that wraps the stacked bar graph component.
 */
export const maxGraphBoxWidth = 1200

export const fertilizerLegendItems = [
    { value: 'Synthetic', color: fertilizerColors['Synthetic'] },
    { value: 'Organic', color: fertilizerColors['Organic'] },
];

export const agrochemicalsLegendItems = [
    { value: 'Herbicide', color: agrochemicalsColors['Herbicide'] },
    { value: 'Pesticide', color: agrochemicalsColors['Pesticide'] },
    { value: 'Insecticide', color: agrochemicalsColors['Insecticide'] },
];

export const tooltipContainer = {
    background: '#fff',
    border: `2px solid #ccc`,
    p: 1,
    borderRadius: 2
}

export const tooltipText = {
    fontWeight: 'bold',
    textDecoration: 'underline',
    textDecorationThickness: "1px",
    textUnderlineOffset: '12%'
}

export const fertilizerBarSize = 100